<mat-slide-toggle [formControlName]="controlKey" color="primary" labelPosition="before">
    <mat-label>{{ labelT | translate }}&nbsp;&nbsp;&nbsp;</mat-label>
</mat-slide-toggle>